import { AppServices } from '@singularsystems/neo-core';
import { CommonParticipantsTypes } from './CommonParticipantTypes';
import ParticipantModuleConfigApiClient from './ApiClients/ParticipantModuleConfigApiClient';
import BeneficiariesApiClient from './ApiClients/BeneficiariesApiClient';
import CountriesApiClient from './ApiClients/CountriesApiClient';
import ParticipantConfigService from './Services/ParticipantConfigService';
import IDTypesApiClient from './ApiClients/IDTypesApiClient';

// Modules
const participantsCommonModule = new AppServices.Module("ParticipantsCommon", container => {
    // Api Clients
    container.bind(CommonParticipantsTypes.ApiClients.ParticipantModuleConfigApiClient).to(ParticipantModuleConfigApiClient).inSingletonScope();
    container.bind(CommonParticipantsTypes.ApiClients.BeneficiariesApiClient).to(BeneficiariesApiClient).inSingletonScope();
    
    // Services
    container.bind(CommonParticipantsTypes.Services.ParticipantConfigService).to(ParticipantConfigService).inSingletonScope();
});

export { participantsCommonModule };